// @flow

import * as api from '../../../../api/api';
import { ACTIONS } from '../actions';

export default async function loadMarketplaceProducts(dispatch: Function) {
    const products = await api.get(`/v5/analytics/marketplaceTeams`);

    dispatch({
        type: ACTIONS.LOAD_MARKETPLACE_PRODUCTS,
        products
    });
}



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/actionCreators/loadMarketplaceProducts.js